module.exports = __webpack_public_path__ + "img/icon-phone.d0564dd9.svg";